import { OnfidoVerification } from "./components";

function App() {
  return (
    <OnfidoVerification />
  );
}

export default App;
